// extracted by mini-css-extract-plugin
export default {"dockVoid":"DockVoid_dockVoid__rXbu4","active":"DockVoid_active__UFqVn"};